export const EMAIL_REGEXP =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const MOBILE_REGEXP = /^$|^374\d{8}$/;

export const SSN_REGEXP = /^$|^\d{10}$/;

export const ARCA_MIR = "arca-mir";
export const ARCA_TOUCH = "arca-touch";
export const ARCA_TRANSFER = "arca-transfer";
export const ARCA_MIMO_BIKE = "arca-mimo-bike";

export const VISA_CLASSIC = "visa-classic";
export const VISA_GOLD = "visa-gold";
export const VISA_INFINITE = "visa-infinite";

export const MASTER_CARD_STANDARD = "master-card-standard";
export const MASTER_CARD_GOLD = "master-card-gold";

export const VISA_VISION_WHITE_STANDARD = "visa-vision-white";
export const VISA_VISION_BLACK_STANDARD = "visa-vision-black";

export const UPI_PLATINUM = "up-platinum";
export const UPI_GOLD = "up-gold";

export const TRAVEL_CARD = "travel-card";
